/**
 * Analytics Configuration
 * Centralized configuration for Google Analytics
 */
export const analyticsConfig = {
    // Google Analytics Measurement ID
    // Replace with your actual GA4 measurement ID (format: G-XXXXXXXXXX)
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',

    // Enable/disable analytics
    enabled: ['true', '1', 'yes', 'y'].includes(import.meta.env.VITE_GA_ENABLED),

    // Debug mode (logs all tracking events to console)
    debug: ['true', '1', 'yes', 'y'].includes(import.meta.env.VITE_GA_DEBUG) || import.meta.env.DEV,

    // Test mode (initializes GA but doesn't send data)
    testMode: ['true', '1', 'yes', 'y'].includes(import.meta.env.VITE_GA_TEST_MODE) || false,

    // Additional options
    options: {
        // Cookie configuration for persistent user identification
        // SameSite=None;Secure allows cross-site cookie tracking (required for some deployments)
        // Use SameSite=Lax for same-site only tracking
        cookieFlags: 'SameSite=Lax;Secure',
        cookieDomain: 'auto', // Auto-detect domain for proper subdomain handling
        cookieExpires: 63072000, // 2 years in seconds - ensures long-term user identification

        // Anonymize IP addresses for privacy compliance (GDPR/CCPA)
        // Note: This doesn't affect user identification via cookies/user_id
        anonymizeIp: true,
    },
} as const;
